import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

export function SlideOneTreeBlock({ children }) {
  return <div className="slideOneTreeBlock">{children}</div>;
}

SlideOneTreeBlock.propTypes = {
  /**
   * All the tree block NodeHolders and dropped components
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};
